import { useState, useEffect, useRef } from "react";
import { Clock } from "lucide-react";
import { apiService } from "../utils/api";
import { CategorySidebar } from "../components/shared/CategorySidebar";

const TVGuidePage = () => {
  const [guide, setGuide] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [loading, setLoading] = useState(true);
  const guideRef = useRef(null);
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [guideRes, catRes] = await Promise.all([
          apiService.getTVGuide(12),
          apiService.getCategories()
        ]);
        setGuide(guideRes.data.channels);
        setCategories(catRes.data);
        setLoading(false);
      } catch (error) {
        console.error('Error:', error);
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const filteredGuide = selectedCategory 
    ? guide.filter(ch => ch.category_id === selectedCategory)
    : guide;

  const timeSlots = [];
  const now = new Date();
  for (let i = -1; i < 6; i++) {
    const time = new Date(now);
    time.setMinutes(Math.floor(now.getMinutes() / 30) * 30 + i * 30, 0, 0);
    timeSlots.push(time);
  }

  return (
    <div className="min-h-screen bg-[#0a0a0a] pt-44" data-testid="guide-page">
      <div className="flex h-[calc(100vh-4rem)]">
        <CategorySidebar categories={categories} selectedCategory={selectedCategory} onSelectCategory={setSelectedCategory} />
        <div className="flex-1 flex flex-col overflow-hidden">
          <div className="flex border-b border-gray-800 bg-black/50 sticky top-0 z-10">
            <div className="w-48 flex-shrink-0 p-3 border-r border-gray-800">
              <div className="flex items-center gap-2 text-sm text-gray-400">
                <Clock size={16} />
                <span>Now: {now.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}</span>
              </div>
            </div>
            <div className="flex-1 flex overflow-x-auto" ref={guideRef}>
              {timeSlots.map((time, i) => (
                <div key={i} className="flex-shrink-0 w-48 p-3 border-r border-gray-800 text-center">
                  <span className={`text-sm ${i === 1 ? 'text-red-500 font-bold' : 'text-gray-400'}`}>
                    {time.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}
                  </span>
                </div>
              ))}
            </div>
          </div>
          <div className="flex-1 overflow-y-auto">
            {loading ? (
              <div className="flex items-center justify-center h-64"><div className="text-gray-400">Loading guide...</div></div>
            ) : (
              filteredGuide.map((channel) => (
                <div key={channel.channel_id} className="flex border-b border-gray-800 hover:bg-white/5">
                  <div className="w-48 flex-shrink-0 p-3 border-r border-gray-800 flex items-center gap-3">
                    <span className="text-xs text-gray-500 w-6">{channel.channel_number}</span>
                    <img src={channel.channel_logo} alt="" className="w-8 h-8 rounded" />
                    <span className="text-sm font-medium truncate">{channel.channel_name}</span>
                  </div>
                  <div className="flex-1 flex overflow-x-auto">
                    {channel.programs.slice(0, 7).map((program) => {
                      const isNow = new Date(program.start_time) <= now && new Date(program.end_time) > now;
                      return (
                        <div key={program.id} className={`flex-shrink-0 p-2 border-r border-gray-800 cursor-pointer hover:bg-white/10 ${isNow ? 'bg-red-900/30' : ''}`} style={{ width: `${Math.max(program.duration / 30 * 192, 96)}px` }}>
                          <p className="text-sm font-medium truncate">{program.title}</p>
                          <p className="text-xs text-gray-500">
                            {new Date(program.start_time).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}
                            {' - '}
                            {new Date(program.end_time).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}
                          </p>
                        </div>
                      );
                    })}
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TVGuidePage;
